// @Version: 1.0.0
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PARAMETER } from './csv-list.model';
import { ILinkList } from 'src/app/shared/pipes/link-list/link-list.model';

@Component({
   selector: 'app-nav-csv-list',
   templateUrl: './csv-list.component.html',
   standalone: false
})
export class NavListCSVComponent {

   @Input() list: ILinkList[] = []

   @Output() public sidenavClose = new EventEmitter();
   
   constructor (public router: Router) {}
   
   public onNavListClick (url: string, name: string, target?: string,): void {
      target && target == PARAMETER.BLANK ? window.open(url, target) : this.router.navigate([url]);
      
      this.sidenavClose.emit();
   }
}
